import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { COURSE_INFO_LINKS } from '../../course.constants';
import { ContentLanguageService } from '../../services/content-language.service';

@Component({
  selector: 'app-app-footer',
  imports: [CommonModule],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss'
})
export class AppFooterComponent {
  private readonly languageService = inject(ContentLanguageService);
  readonly contentLanguage = this.languageService.current;
  readonly footerLinks = COURSE_INFO_LINKS;

  readonly currentYear = new Date().getFullYear();
}
